import { PopupConfigService } from './popup_config_service/popup_config_service';

angular.module('ui-ng-popup').service('ngPopupService', PopupConfigService);

export * from './popup_config_service/popup_config_service_type';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-popup/src/services/services_module.ts